module.exports = __webpack_public_path__ + "static/media/asterisk.a4dbc582.svg";